import autouploadImage from 'img/promo-block-mobile/autoupload.png';
import autouploadMobilePromoImage from 'img/promo-block-mobile/autoupload-mobile-promo.png';

import { type PromoBlockBase, PromoBlockBgColor, PromoBlockButtonColor, PromoBlockId, PromoBlockTextColor } from './PromoBlock.types';

export const PromoBlockData: Record<PromoBlockId, PromoBlockBase> = {
    [PromoBlockId.AUTOUPLOAD]: {
        id: PromoBlockId.AUTOUPLOAD,
        title: 'Безлимит на полную',
        text: 'Автозагрузка галереи с\u00A0телефона теперь не\u00A0займёт место в\u00A0Облаке',
        textColor: PromoBlockTextColor.black,
        buttonText: 'Подробнее',
        buttonColor: PromoBlockButtonColor.black,
        backgroundColor: PromoBlockBgColor.lightBlue,
        image: autouploadImage,
        analyticsName: 'touch_promo_block_autoupl',
        imageFullHeight: true,
    },
    [PromoBlockId.AUTOUPLOAD_LANDING]: {
        id: PromoBlockId.AUTOUPLOAD_LANDING,
        title: 'Безлимитная память телефона',
        text: 'Фото и\u00A0видео с\u00A0телефона не\u00A0займут место в\u00A0Облаке. Новая возможность Mail\u00A0Space',
        textColor: PromoBlockTextColor.white,
        buttonText: 'Попробовать',
        buttonColor: PromoBlockButtonColor.gray,
        buttonSecondaryText: 'Как работает?',
        backgroundColor: PromoBlockBgColor.blue,
        image: autouploadMobilePromoImage,
        analyticsName: 'touch_promo_autoupl_landing',
        imageFullHeight: true,
        showOnce: false,
        closable: false,
        secondaryButtonAsLink: true,
    },
    [PromoBlockId.PRE_OVERQUOTA]: {
        id: PromoBlockId.PRE_OVERQUOTA,
        title: 'Скоро в Почте и Облаке могут начаться ограничения — как избежать',
        text: 'Увеличьте на 256 ГБ с подпиской Mail Space, не будет ограничений на отправку и хранение',
        textColor: PromoBlockTextColor.black,
        buttonText: 'Добавить 256 ГБ',
        buttonColor: PromoBlockButtonColor.red,
        buttonSecondaryText: 'Другие тарифы',
        buttonSecondaryColor: PromoBlockButtonColor.white,
        backgroundColor: PromoBlockBgColor.lightRed,
        image: '',
        analyticsName: 'touch_promo_pre_overq',
        imageFullHeight: false,
        showOnce: false,
        closable: false,
    },
};
